import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AttributeFilter } from 'app/shared/ui/models/attribute-filter';
import { FaDirectiveEnum } from '../../../../../../models/enums/fa-directive.enum';

@Component({
  selector: 'jhi-filter-button',
  templateUrl: './filter-button.component.html',
})
export class FilterButtonComponent {
  @Input() attributeFilter!: AttributeFilter;
  @Output() attributeFilterChange = new EventEmitter<AttributeFilter>();
  @Output() buttonRemoved = new EventEmitter<any>();

  protected readonly FAS = FaDirectiveEnum.FAS;

  removeButton(): void {
    this.attributeFilter.value = undefined;
    this.attributeFilter.tempValue = undefined;
    this.attributeFilter.secondValue = undefined;
    this.attributeFilter.tempSecondValue = undefined;
    this.attributeFilterChange.emit(this.attributeFilter);
    this.buttonRemoved.emit();
  }
}
